"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    name: String,

    fullscreen: {
      type: Boolean,
      default: true,
      required: false
    }
  },

  data: function data() {
    return {
      show: false,
      params: null,
      editMode: false,
      duration: undefined
    };
  },


  computed: {
    eventName: function eventName() {
      return "toggle-" + this.name + "-menu";
    }
  },

  created: function created() {
    Event.listen(this.eventName, this.toggleMenu);
  },
  mounted: function mounted() {
    if (this.$store.state.requestErrors[this.name] !== undefined) {
      this.params = this.$store.state.requestErrors[this.name]["params"];
      this.duration = 0;
      this.show = true;
    }

    this.$on("editing", this.onEditingProfile);
  },


  methods: {
    toggleMenu: function toggleMenu(params) {
      this.params = params;
      this.show = !this.show;
    },
    close: function close() {
      this.duration = undefined;
      Event.fire(this.eventName);
    },
    onEditingProfile: function onEditingProfile(isEditing) {
      this.editMode = isEditing;
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.$off("editing", this.onEditingProfile);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/menu/RightMenuWrapper.vue
// module id = kPBZ
// module chunks = 0 1